"use strict";import{Icon as e}from"./src/Icon.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-icon",e);
//# sourceMappingURL=sp-icon.js.map
